<script>
    import { getNewIcon } from '../../card_images';
	import { getSuitColor } from '../helpers';
	import "../shared.css";

	export let suit;
	export let botLabel = false;
	export let restriction;

	$: color = getSuitColor(suit, true);
	$: label = suit === 'qsuit' ? 'Q' : suit.toUpperCase();
</script>

<div class="suit-chip" style="--bgc:{color};--indent:{botLabel ? 1 : 0}em;--outline:{restriction ? 2 : 0}px;">
	{#if !botLabel && suit !== 'status'}
		<img src={getNewIcon(suit)} />
	{/if}
	<span class="label font-heading">{label}</span>
</div>

<style lang="scss">
	.suit-chip {
		background-color: var(--bgc);
		display: inline-flex;
		height: 0.95em;
		border-radius: calc(var(--width) / 0.574); //500px;
		color: white;
		padding: 0em 0.3em 0em 0.3em;
		align-items: center;
		gap: calc(var(--width) / 143.5); //2px;
		& > :global(img) {
			filter: brightness(0) invert(1);
			width: auto;
			height: 80%;
		}
	}
	.label {
		font-size: 0.75em;
		font-weight: 300;
		margin-top: -0.05em;
		text-indent: var(--indent);
	}
</style>
